import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Card } from '@utilities';
import { getTileIcon } from '../../utilities/helpers';
import styles from './_index.module.scss';

const InteractiveTile = ({ onClick, route }) => {
  const { description, enabled, id, name } = route;
  const isComingSoon = enabled === false;
  const tileIcons = getTileIcon({ enabled, narrativeId: id });

  return (
    <Card
      as="button"
      className={classNames(styles['interactive-tile'], {
        [styles['is-coming-soon']]: isComingSoon,
      })}
      disabled={isComingSoon}
      elevation={1}
      onClick={() => {
        if (isComingSoon) return;
        onClick(route);
      }}
    >
      <div className={styles['interactive-tile-icon-wrapper']}>
        <span className={styles['interactive-tile-default-icon']}>{tileIcons.icon}</span>
        <span className={styles['interactive-tile-hover-icon']}>{tileIcons.filledIcon}</span>
      </div>
      <h3 className={styles['tile-title']}>{name}</h3>
      <p className={styles['tile-description']}>{description}</p>
    </Card>
  );
};

InteractiveTile.propTypes = {
  onClick: PropTypes.func.isRequired,
  route: PropTypes.object.isRequired,
};

export default InteractiveTile;
